import { Pipe, PipeTransform } from '@angular/core';
import { User } from '@karve.it/interfaces/auth';

/**
 * Formats a phone number string according to country/city/base logic.
 * @param tel The phone number as string or number.
 * @param showCountry Whether to show the country code.
 * @returns Formatted phone number string.
 */
export function formatPhoneNumber(tel: string, showCountry: boolean) {
  if (!tel) { return 'No Phone'; }

  const value = tel.toString().trim().replace(/^\+/, '');

  if (value.match(/[^0-9]/)) {
    return tel;
  }

  let country; let city; let base;

  switch (value.length) {
    case 10:
      country = 1;
      city = value.slice(0, 3);
      base = value.slice(3);
      break;

    case 11:
      country = value[0];
      city = value.slice(1, 4);
      base = value.slice(4);
      break;

    case 12:
      country = value.slice(0, 3);
      city = value.slice(3, 5);
      base = value.slice(5);
      break;

    default:
        return tel;
  }

  if (!showCountry && country === 1) {
    country = '';
  }

  base = `${base.slice(0, 3)}-${base.slice(3)}`;

  return `${country ? '+' + country : country} ${city} ${base}`.trim();
}

@Pipe({
  name: 'phone'
})
export class PhonePipe implements PipeTransform {

  transform(user: User, showCountry: boolean): string {
    if (!user || !user.phone) { return 'No Phone'; }
    return formatPhoneNumber(user.phone, showCountry);
  }

}
